import * as yup from "yup";

const ItemValidacion = yup.object().shape({
    item: yup.string().required(),
    model: yup.string().required()
});

export default ItemValidacion;